import get from "lodash/get";
import React, {Component} from "react";
import compose from "lodash/flowRight";
import {graphql, withApollo} from "react-apollo";
import {connect} from "react-redux";

import RecordAnalytics from "shared/Analytics/RecordAnalytics";
import {BlogPostPlaceholder} from "shared/Blog/components/BlogPostPlaceholder/BlogPostPlaceholder";
import PostPreviewCard from "shared/Blog/components/BlogPostPreviewCard/BlogPostPreviewCard";
import {NoDataMessage} from "shared/Blog/components/NoDataMessage/NoDataMessage";
import ProgressBar from "shared/General/components/ProgressBar/ProgressBar";
import blogPostsQuery from "shared/Blog/queries/blogPostsQuery";
import withOpenInJigglypuff from "shared/Navigation/hocs/withOpenInJigglypuff";

import {PageTitle} from "../../../../components/PageTitle/PageTitle";
import {AppContainer} from "../../../../widgets/shared/components/Containers/AppContainer";

export class EmbeddedBlogPostListComponent extends Component {
    componentDidMount() {
        RecordAnalytics.page(this.props, "Blog List Page");
    }

    onSelectPost(postId) {
        RecordAnalytics.event(this.props, "View Blog Post Clicked", {postId});
        this.props.openInJigglypuff(`blog/post/${postId}`);
    }

    onSelectAuthor(authorId) {
        RecordAnalytics.event(this.props, "View Blog Post Author Clicked", {authorId});
        this.props.openInJigglypuff(`buddies/${authorId}`);
    }

    render() {
        const posts = get(this.props, "posts", []);

        const postNodes = !(this.props.loading && posts.length === 0) ? (
            posts.map((post) => (
                <PostPreviewCard
                    key={post.id}
                    post={post}
                    authorUrl={this.props.location.pathname}
                    postUrl={this.props.location.pathname}
                    onSelectPost={() => this.onSelectPost(get(post, "id", ""))}
                    onSelectAuthor={() => this.onSelectAuthor(get(post, "author.id", ""))}
                    showAuthor
                />
            ))
        ) : (
            <div>
                <BlogPostPlaceholder />
            </div>
        );

        return (
            <div>
                <PageTitle title="Blogs" />
                <ProgressBar start={this.props.loading} />
                <AppContainer id="blog-container">
                    {!this.props.loading && posts.length === 0 ? <NoDataMessage /> : null}
                    {postNodes}
                </AppContainer>
            </div>
        );
    }
}

const blogPostsQueryOptions = {
    name: "blogPostsQuery",
    options(props) {
        const filter = props.match.params.filter;
        const value = props.match.params.value;

        // convert topic filter into an array of topic filters
        const variables = filter === "topic" ? {topics: [value]} : {[filter]: value};

        return {
            variables: {
                universitySlug: get(props, "match.params.universitySlug", ""),
                limit: props.match.params.limit,
                ...variables,
            },
            fetchPolicy: "cache-and-network",
        };
    },
    props({blogPostsQuery: {loading, allPosts, refetch}}) {
        return {
            loading,
            posts: allPosts,
            refetch,
        };
    },
};

export default compose(
    connect(),
    withApollo,
    withOpenInJigglypuff,
    graphql(blogPostsQuery, blogPostsQueryOptions),
)(EmbeddedBlogPostListComponent);
